module.exports = __webpack_public_path__ + "images/aller-national-logo-black_8ccf88822f23b82e671a98089910cc62.svg";